module.exports = {
    'listGameInstances': '/api/cps/instances/listGameInstances',
    'listGameSpecs': '/api/cps/instances/listGameSpecs',
    'createGameInstance': '/api/cps/instances/createGameInstance',
};



// WEBPACK FOOTER //
// ./src/api/game/config.js